import {
  cylinders,
  vehicleBodyType,
  vehicleMakeData,
  vehicleModelData,
  vehicleUsage,
} from "../config/oqic";
import { getAgeFromDOB, getISOFormattedDate } from "./commonHelper";
// import { generateUniqueStringWithTime } from "./gigHelpers";

export const prepareOqicQuoteData = (vehicleData, formData) => {
  const { ropLicense, ropVehicle } = vehicleData || {};

  if (!ropLicense || !ropVehicle) {
    console.error("Invalid vehicle data provided:", vehicleData);
    return {};
  }

  const driverDOB = `${vehicleData?.ropLicense?.Body?.GetLicenseInfoResponse?.GetLicenseInfoResult?.DateofBirth?.slice(
    6
  )}/${vehicleData?.ropLicense?.Body?.GetLicenseInfoResponse?.GetLicenseInfoResult?.DateofBirth?.slice(
    4,
    6
  )}/${vehicleData?.ropLicense?.Body?.GetLicenseInfoResponse?.GetLicenseInfoResult?.DateofBirth?.slice(
    0,
    4
  )}`;

  const vehicleType = getBodyTypeCodeByDescription(
    vehicleData?.ropVehicle?.Body?.GetVehicleValuationByPlateResponse
      ?.GetVehicleValuationByPlateResult?.VehicleInfo?.VehicleTypeDesc,
    vehicleBodyType
  );

  const makeCode = getMakeCodeByDescription(
    vehicleData?.ropVehicle?.Body?.GetVehicleValuationByPlateResponse
      ?.GetVehicleValuationByPlateResult?.VehicleInfo?.VehicleMakeDesc,
    vehicleMakeData
  );

  const modelCode = getModelCodeByMakeCode(makeCode, vehicleModelData);

  let ropVehicleVinDecoding =
    vehicleData?.ropVehicle?.Body?.GetVehicleValuationByPlateResponse
      ?.GetVehicleValuationByPlateResult?.result?.vin_decoding;

  let vehicleDescription =
    vehicleData?.ropVehicle?.Body?.GetVehicleValuationByPlateResponse
      ?.GetVehicleValuationByPlateResult?.result?.vehicle_description
      ?.Vehicle_Description;
  let ropVehicleDescription;
  if (Array.isArray(vehicleDescription)) {
    ropVehicleDescription = vehicleDescription?.find(
      (item) => item?.admeid === ropVehicleVinDecoding?.admeid
    );
  } else {
    ropVehicleDescription = vehicleDescription;
  }

  console.log("ropVehicleDescription::  ", { ropVehicleDescription });

  const noOfCylinder = getCylinderCode(
    ropVehicleDescription?.no_of_cyls,
    cylinders
  );

  // cylinders

  //Plan Type :: Start
  let productDetail = localStorage.getItem("product_details")
    ? JSON.parse(localStorage.getItem("product_details"))
    : null;
  let plan_type;
  if (productDetail && productDetail?.sub_product_id === 21) {
    plan_type = "Comprehensive";
  } else {
    plan_type = "Third party";
  }
  //Plan Type :: End

  const reqData = {
    oquicDriverDOB: driverDOB,
    insuredAge: getAgeFromDOB(driverDOB),
    oquicNationality: "",
    modelYear:
      vehicleData?.ropVehicle?.Body?.GetVehicleValuationByPlateResponse
        ?.GetVehicleValuationByPlateResult?.VehicleInfo?.MakeYear,
    oquicVehicleType: vehicleType,
    oquicMakeCode: makeCode,
    oquicModelCode: modelCode,
    "chassisNo": vehicleData?.ropVehicle?.Body
        ?.GetVehicleValuationByPlateResponse
        ?.GetVehicleValuationByPlateResult?.VehicleInfo?.ChassisNumber,
    // chassisNo: generateUniqueStringWithTime(),
    gccSpec: 1,
    oquicNoOfCylinder: noOfCylinder,
    seatingCapacity: ropVehicleDescription?.seats?.match(/\d+/)?.[0] || "",
    firstRegDate: `${vehicleData?.ropVehicle?.Body?.GetVehicleValuationByPlateResponse?.GetVehicleValuationByPlateResult?.VehicleInfo?.RegistrationIssueDate?.slice(
      6
    )}/${vehicleData?.ropVehicle?.Body?.GetVehicleValuationByPlateResponse?.GetVehicleValuationByPlateResult?.VehicleInfo?.RegistrationIssueDate?.slice(
      4,
      6
    )}/${vehicleData?.ropVehicle?.Body?.GetVehicleValuationByPlateResponse?.GetVehicleValuationByPlateResult?.VehicleInfo?.RegistrationIssueDate?.slice(
      0,
      4
    )} `,
    vehicleUsage: getVehicleUsageCodeByDescription(
      vehicleData?.ropVehicle?.Body?.GetVehicleValuationByPlateResponse
        ?.GetVehicleValuationByPlateResult?.VehicleInfo?.RegistraionTypeDesc,
      vehicleUsage
    ),
    policyFromDate: getISOFormattedDate(1).substring(0, 10),
    sumInsured:
      plan_type === "Comprehensive" ? formData?.vehicle_valuation : "",
    previousInsuranceValid: isDatePassed(
      vehicleData?.ropVehicle?.Body?.GetVehicleValuationByPlateResponse
        ?.GetVehicleValuationByPlateResult?.VehicleInfo?.InsuranceEndDate
    ),
    totalLoss: "0",
    admeId: ropVehicleDescription?.admeid,
    regYear:
      vehicleData?.ropVehicle?.Body?.GetVehicleValuationByPlateResponse?.GetVehicleValuationByPlateResult?.VehicleInfo?.RegistrationIssueDate?.slice(
        0,
        4
      ),
    geoArea:
      vehicleData?.ropVehicle?.Body?.GetVehicleValuationByPlateResponse?.GetVehicleValuationByPlateResult?.VehicleInfo?.InsuranceTypeDesc?.toLowerCase()?.includes(
        "oman and uae"
      )
        ? "6001"
        : "6002",
    mobileNo: "971565464564",
  };

  // console.log("OQUIC:: ", { reqData });
  return reqData;
};

export const getBodyTypeCodeByDescription = (description, bodyTypes) => {
  const match = bodyTypes?.find(
    (item) => item?.description?.toLowerCase() === description?.toLowerCase()
  );
  return match ? match.body_type_codes : null;
};

export const getMakeCodeByDescription = (description, makeList) => {
  const match = makeList.find(
    (item) => item?.description?.toLowerCase() === description?.toLowerCase()
  );
  return match ? match.make_codes : null;
};

export const getModelCodeByMakeCode = (
  makeCode,
  models,
  description = null
) => {
  const match = models.find((item) => {
    const isMakeMatch = item.make_code === makeCode;
    const isDescMatch = description
      ? item?.description?.toLowerCase() === description?.toLowerCase()
      : true;
    return isMakeMatch && isDescMatch;
  });

  return match ? match.model_code : null;
};

export const getCylinderCode = (noOfCylinder, cylinders) => {
  const descStr = String(noOfCylinder).trim(); // Convert input to string
  const match = cylinders.find(
    (item) => String(item.description).trim() === descStr
  );
  return match ? match.cylinder_codes : null;
};

export const getVehicleUsageCodeByDescription = (description, usages) => {
  const descStr = String(description)?.trim()?.toLowerCase();

  const match = usages.find(
    (item) => String(item.description)?.trim()?.toLowerCase() === descStr
  );

  return match ? match.usage_codes : null;
};

export const isDatePassed = (yyyymmddStr) => {
  if (!/^\d{8}$/.test(yyyymmddStr)) return false; // Invalid format

  const year = parseInt(yyyymmddStr.slice(0, 4), 10);
  const month = parseInt(yyyymmddStr.slice(4, 6), 10) - 1; // JS months: 0-11
  const day = parseInt(yyyymmddStr.slice(6, 8), 10);

  const inputDate = new Date(year, month, day);
  const today = new Date();

  // Set today's time to midnight to avoid time conflicts
  today.setHours(0, 0, 0, 0);

  return inputDate < today ? 0 : 1; // Return 0 if date is passed, else return 1
};

export const getCodeByDescription = (description, colourData) => {
  // Get colour code from description
  const match = colourData.find(
    (item) => item?.description?.toLowerCase() === description?.toLowerCase()
  );
  return match ? match.colour_codes : "99";
};

export const extractSelectedSchemes = (data) => {
  const result = {
    schemeCode: data.schemeCode,
    productCode: data.productCode,
  };

  const selectedOptionalCovers = (data.optional_covers || [])
    .filter((cover) => cover.isSelected)
    .map((cover) => ({ code: cover.code }));
  if (selectedOptionalCovers.length > 0) {
    result.optionalCovers = selectedOptionalCovers;
  }

  return [result];
};

export const prepareOquicInsuranceCardData = (
  companyList,
  travelProductType
) => {
  let data = [];
  if (companyList && companyList.length) {
    companyList.forEach((company, index) => {
      let cells = company?.extracted_data?.schemes || [];
      // console.log({ cells });
      let travel_product_type =
        travelProductType && travelProductType.length
          ? travelProductType[0]?.options
          : [];

      if (cells && cells.length) {
        cells.forEach((cell, cellIndex) => {
          // console.log({ cell });

          data.push({
            product_id: company?.product_id,
            sub_product_id: company?.sub_product_id,
            object_id: cellIndex,
            company_name: company?.insurance_company?.company_title,
            company_name_ar: company?.insurance_company?.company_title_ar,
            company_description_en:
              company?.insurance_company?.company_descriptions_en,
            company_description_ar:
              company?.insurance_company?.company_descriptions_ar,
            company_faq_en: company?.insurance_company?.faq_en,
            company_faq_ar: company?.insurance_company?.faq_ar,
            company_id: company?.insurance_company?.id,
            company_image: company?.insurance_company?.image,
            email: company?.extracted_data?.email,
            mobile_no: company?.extracted_data?.mobile_no,
            plan_name: cell?.schemeName || "",
            base_price: cell?.netPremium || 0,
            premium_value: cell?.netPremium || 0,
            premium_currency: "OMR",
            productCode: cell?.productCode || "",
            schemeCode: cell?.schemeCode || "",
            included_covers:
              cell?.basicCovers?.concat(cell?.inclusiveCovers) || [],
            optional_covers:
              cell?.optionalCovers?.map((item) => ({
                ...item,
                isSelected: false,
              })) || [],
            extracted_data: company?.extracted_data || {},
            insurance_company_product_mapping_id: company?.id,
            area_of_coverage:
              travel_product_type.find(
                (tp) => tp.company == company?.insurance_company?.id
              ) || null,
          });
        });
      } else {
        console.warn(
          "No schemes found for company:",
          company?.insurance_company?.company_title
        );
      }
    });
  }

  return data;
};

export const generateCovers = (data, product_id, sub_product_id) => {
  const covers = [];
  if (product_id === 1 && (sub_product_id === 1 || sub_product_id === 21)) {
    for (let i = 1; i <= 17; i++) {
      const key = `cover_${i}_name`;
      const value = data[key];
      if (value && value.trim() !== "") {
        covers.push({ cover_description: value.trim(), cover_coverage: null });
      }
    }
  } else {
    Object.keys(data).forEach((key) => {
      if (key.endsWith("_h")) {
        const baseKey = key.slice(0, -2); // remove '_h'
        const cover_description = data[key];
        const cover_coverage = data.hasOwnProperty(baseKey)
          ? data[baseKey]
          : null;

        // Only include if cover_coverage is not null or undefined
        if (cover_coverage !== null && cover_coverage !== undefined) {
          covers.push({
            cover_description,
            cover_coverage,
          });
        }
      }
    });
  }

  return covers;
};
